module.exports = __webpack_public_path__ + "02_hige_black.5b7e37b1.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/dad/layer3/02_hige_black.png
// module id = iTGo
// module chunks = 0